module.exports = __webpack_public_path__ + "img/6.0e674c18.png";